module.exports = __webpack_public_path__ + "static/media/lucille-graham.3160549c.jpg";